import { Map, fromJS } from 'immutable';

import Actions from 'flow/actions';

const initialState = Map();

const voicemailsReducer = (state = initialState, action) => {
    switch (action ? action.type : null) {
        case Actions.CLEAR_STATE:
            return initialState;
        case Actions.RESULT_VOICEMAIL_SETTINGS:
            return state.update(action.key, Map(), (prev) =>
                prev.mergeDeep(fromJS(action.data)),
            );
        case Actions.RESULT_VOICEMAIL_SETTINGS_UNAVAILABLE:
            return state.update(action.key, Map(), () => null);
        default:
            return state;
    }
};

export default voicemailsReducer;
